<template>
	<div>
		<v-expansion-panel
			class="expansion"
		>
			<v-expansion-panel-content
				v-for="(item, i) in templates"
				:key="i"
			>
				<template slot="header" tag="div">
					<div class="wrapper-header">
						<div class="panel-title"
							:style="`color:${$appColors.primary}`"
						>{{item.name}}</div>
						<button
							type="button"
							class="panel-selection-btn"
							:style="`background-color:${$appColors.primary}`"
							@click.stop="selecting(item)"
						>Seleccionar</button>
					</div>
				</template>
				<div class="answer-container">
					<div
						class="answer"
						:style="`border:1px solid ${$appColors.primary}`"
						v-for="(ans, indexA) in item.details"
						:key="indexA"
					>
						<img v-if="ans.urlImage" :src="ans.urlImage.web" alt="">
						<h4 class="name-title">{{ans.name}}</h4>
						<span
							:style="`color:${$appColors.primary}`"
							class="value-title">Valor: {{ans.value}}</span>
					</div>
				</div>
			</v-expansion-panel-content>
    	</v-expansion-panel>
	</div>
</template>
<script>

function selecting(answer) {
	this.$store.dispatch('answer/selectedTypeAnswer', answer.id);
	this.showNotification(
		`Tipo de respuesta ${answer.name} seleccionada`,
		'success',
	);
	this.$router.back();
}

function buildTabs(item) {
	return item.aspects.map(i => i.title);
}

function buildTabsContent(item) {
	return item.aspects.map(i => ({
		content: i.content,
		title: i.title,
		imgs: i.imgs,
	}));
}

export default {
	name: 'answer-by-tool',
	methods: {
		buildTabs,
		buildTabsContent,
		selecting,
	},
	props: {
		templates: {
			type: Array,
			required: true,
		},
	},
};
</script>
<style lang="scss" scoped>
.expansion {
	
	.v-expansion-panel__container {
		background-color: color(border-gray);
		border-top: none;
		margin-bottom: 5px;
	}

	.wrapper-header {
		align-items: center;
		display: flex;
		justify-content: space-between;

		.panel-title {
			font-family: font(bold);
			font-size: size(medium);
		}

		.panel-selection-btn {
			border-radius: 4px;
			color: white;
			margin-right: 10px;
			padding: 5px 10px;
		}
	}

	.answer-container {
		align-items: center;
		background-color: color(gray-light);
		display: grid;
		grid-gap: 10px;
		grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
		height: 100%;
		padding: 18px 9px;

		.answer {
			align-items: center;
			border-radius: 7px;
			display: flex;
			flex-direction: column;
			height: inherit;
			justify-content: flex-start;
			padding: 10px 8px 5px;

			img {
				height: 37px;
				margin-bottom: 5px;
				width: 37px;
			}

			.name-title {
				text-align: center;
			}

			.value-title, .weight-title {
				font-family: font(bold);
				font-size: size(small);
			}
		}
	}


}
</style>


// WEBPACK FOOTER //
// src/components/configuration/tools/answers-by-tool.vue